import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {CustomersService} from "app/services";
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {getApiErrorMessage} from "app/utils/getApiErrorMessage";
import {fetchAllCustomers} from "./customers-list.slice";
import {CreateCustomerTypes} from "app/types/service-types/CustomerTypes";

interface CreateCustomerStateParams {
  body: CreateCustomerTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const createCustomer = (params: CreateCustomerStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await CustomersService.createCustomer(params.body);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en' ? 'Customer added successfully!' : 'Klienti u shtua me sukses!'));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(fetchAllCustomers());
    }
  } catch (err: unknown) {
    const message = getApiErrorMessage(err);

    dispatch(errorMsg(message));
    if (params.onError) params.onError();
    dispatch(setError(message));
  } finally {
    dispatch(setLoading(false));
  }
}

interface CreateCustomerSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateCustomerSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'customer/create-customer',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
})

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
